import { useEffect, useRef, useState } from 'react'
import { INBOX_TAG_SETTLE_MS, inboxTagsChanged, type InboxFilters } from './inboxFilters'

/** Keeps tag edits off the list request until the selection pauses. Other filters apply immediately. */
export function useSettledInboxFilters(filters: InboxFilters): InboxFilters {
  const [settled, setSettled] = useState(filters)
  const latest = useRef(filters)
  latest.current = filters

  useEffect(() => {
    if (!inboxTagsChanged(settled, filters)) {
      setSettled(filters)
      return
    }
    const timer = window.setTimeout(() => setSettled(latest.current), INBOX_TAG_SETTLE_MS)
    return () => window.clearTimeout(timer)
  }, [filters, settled])

  return settled
}
